const productStack = ['Flutter', 'Dart', 'React', 'JavaScript', 'Python', 'REST APIs'];
const aiStack = ['TensorFlow Lite', 'ONNX Runtime', 'YOLOv8', 'MobileNetV2', 'DenseNet121', 'TinyViT-5M', 'OpenCV'];
const backendStack = ['Supabase', 'PostgreSQL', 'Node.js', 'Deno', 'Edge Functions', 'RLS'];
const connectedStack = ['ESP32', 'Arduino', 'PySerial', 'Edge Computing', 'Solar Systems'];
const familiarStack = ['Java', 'Material Design', 'Riverpod', 'Provider'];
const aiTools = ['GitHub Copilot', 'Claude', 'ChatGPT'];
const workflowTools = ['Android Studio', 'VS Code', 'Git / GitHub', 'Google Colab', 'Arduino IDE', 'Firebase', 'Figma'];

const Tag = ({ children, prominent = false }) => (
  <span className={prominent
    ? 'rounded-lg border border-[#22C55E]/40 bg-[#18181B] px-4 py-3 font-mono text-sm font-bold text-[#EDEDEF] shadow-sm shadow-[#22C55E]/5'
    : 'rounded-full border border-[#27272A] px-3 py-1.5 font-mono text-xs text-[#8B8B93]'}>
    {children}
  </span>
);

const ToolsPage = () => (
  <section className="max-w-5xl">
    <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#22C55E]">03 / STACK</p>
    <h1 className="mt-5 text-4xl font-mono font-bold text-[#EDEDEF] sm:text-6xl">What I build with.</h1>
    <p className="mt-5 max-w-2xl text-base leading-8 text-[#8B8B93]">
      A working toolkit for turning product ideas into mobile apps, web platforms, AI features, and connected systems.
    </p>

    <div className="mt-14">
      <div className="flex items-baseline justify-between border-b border-[#27272A] pb-4">
        <div><p className="font-mono text-xs uppercase tracking-[0.25em] text-[#22C55E]">01 / Product development</p><h2 className="mt-2 text-2xl font-mono font-bold text-[#EDEDEF]">Applications and platforms</h2></div>
        <span className="font-mono text-xs text-[#8B8B93]">PRIMARY TOOLS</span>
      </div>
      <div className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">{productStack.map((item) => <Tag key={item} prominent>{item}</Tag>)}</div>
    </div>

    <div className="mt-14 border-t border-[#27272A] pt-8">
      <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#8B8B93]">02 / AI and machine learning</p>
      <p className="mt-3 text-sm text-[#8B8B93]">Applied tools for integrating models into useful products and real-world workflows.</p>
      <div className="mt-5 flex flex-wrap gap-2">{aiStack.map((item) => <Tag key={item}>{item}</Tag>)}</div>
    </div>

    <div className="mt-14 grid gap-10 border-t border-[#27272A] pt-8 md:grid-cols-2">
      <div>
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#8B8B93]">03 / Backend and data</p>
        <div className="mt-5 flex flex-wrap gap-2">{backendStack.map((item) => <Tag key={item}>{item}</Tag>)}</div>
      </div>
      <div>
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#8B8B93]">04 / Connected systems</p>
        <div className="mt-5 flex flex-wrap gap-2">{connectedStack.map((item) => <Tag key={item}>{item}</Tag>)}</div>
      </div>
    </div>

    <div className="mt-14 border-t border-[#27272A] pt-8">
      <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#8B8B93]">05 / Broader toolkit</p>
      <div className="mt-5 flex flex-wrap gap-2">{familiarStack.map((item) => <Tag key={item}>{item}</Tag>)}</div>
    </div>

    <div className="mt-14 border-t border-[#27272A] pt-8">
      <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#8B8B93]">06 / Development workflow</p>
      <p className="mt-3 max-w-2xl text-sm leading-7 text-[#8B8B93]">I use Git, VS Code, Android Studio, Google Colab, Arduino IDE, Figma, and AI assistants to move from idea to implementation. They support exploration and review while technical judgment stays with me.</p>
      <div className="mt-5 flex flex-wrap gap-2">{[...workflowTools, ...aiTools].map((item) => <Tag key={item}>{item}</Tag>)}</div>
    </div>

    <p className="mt-14 border-l-2 border-[#22C55E] pl-4 text-sm leading-7 text-[#8B8B93]">
      Technical documentation, product consulting, ML mentoring, and team leadership.
    </p>
  </section>
);

export default ToolsPage;
